import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BookOpen, Receipt } from "lucide-react";
import api from "../../lib/api";
import { naira } from "../../lib/store";
import StoreBooks from "../../components/admin/StoreBooks";
import StoreOrders from "../../components/admin/StoreOrders";

export default function AdminStore() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "orders";
  const [s, setS] = useState(null);
  const loadSummary = () => api.get("/admin/store/summary").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { document.title = "Admin · Book Store"; loadSummary(); }, []);
  return (
    <div data-testid="admin-store">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div><h1 className="font-serif text-3xl font-bold mb-1">Book Store</h1><p className="text-[#0a0d12]/60 text-sm">Upload books, confirm bank transfers, grant PDF access and ship hard copies. Every confirmed sale is recorded as a donation to the General Project Fund.</p></div>
        {s && <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs" data-testid="store-summary">
          {[["Raised from book sales", naira(s.total_raised), "bg-green-100 text-green-800"], ["Paid orders", s.orders_paid, "bg-[#f8f4e8] text-[#7a5a0f]"], ["Awaiting confirmation", s.pending, "bg-amber-100 text-amber-800"], ["Hard copies to ship", s.to_ship, "bg-blue-100 text-blue-800"]].map(([l, v, c]) => <div key={l} className={`rounded-xl px-3 py-2 ${c}`}><div className="font-bold text-base">{v}</div><div>{l}</div></div>)}
        </div>}
      </div>
      <div className="flex gap-1 mb-5 border-b border-black/10" role="tablist">{[["orders", "Orders & payments", Receipt], ["books", "Books", BookOpen]].map(([k, l, I]) => <button key={k} role="tab" aria-selected={tab === k} onClick={() => setParams({ tab: k })} className={`px-4 py-2 text-sm font-semibold inline-flex items-center gap-2 border-b-2 -mb-px ${tab === k ? "border-[#d6aa43] text-[#0d1724]" : "border-transparent text-[#0a0d12]/60"}`} data-testid={`store-tab-${k}`}><I size={14} /> {l}</button>)}</div>
      {tab === "orders" ? <StoreOrders onChange={loadSummary} /> : <StoreBooks onChange={loadSummary} />}
    </div>
  );
}
